import { instance } from "config/axiosInstance";

const baseURL = process.env.REACT_APP_TENANT_BE;
const base = "/contract-version";

/** GET /contract-version/contract/:contractId/versions */
export async function getContractVersions(contractId) {
  return instance({ baseURL }).get(`${base}/contract/${contractId}/versions`);
}

/** GET /contract-version/:versionId */
export async function getContractVersionById(versionId) {
  return instance({ baseURL }).get(`${base}/${versionId}`);
}

/** POST /contract-version/contract/:contractId/versions */
export async function createContractVersion(contractId, body) {
  return instance({ baseURL }).post(`${base}/contract/${contractId}/versions`, body);
}

/** PUT /contract-version/:versionId */
export async function updateContractVersion(versionId, body) {
  return instance({ baseURL }).put(`${base}/${versionId}`, body);
}

/** DELETE /contract-version/:versionId */
export async function deleteContractVersion(versionId) {
  return instance({ baseURL }).delete(`${base}/${versionId}`);
}

/** POST /contract-version/:versionId/submit */
export async function submitContractVersion(versionId) {
  return instance({ baseURL }).post(`${base}/${versionId}/submit`);
}

/** POST /contract-version/:versionId/approve */
export async function approveContractVersion(versionId, body) {
  return instance({ baseURL }).post(`${base}/${versionId}/approve`, body);
}

/** POST /contract-version/:versionId/reject */
export async function rejectContractVersion(versionId, body) {
  return instance({ baseURL }).post(`${base}/${versionId}/reject`, body);
}

/** POST /contract-version/:versionId/apply */
export async function applyContractVersion(versionId) {
  return instance({ baseURL }).post(`${base}/${versionId}/apply`);
}

/** GET /contract-version/contract/:contractId/state */
export async function getActiveContractState(contractId) {
  return instance({ baseURL }).get(`${base}/contract/${contractId}/state`);
}

/** GET /contract-version/contract/:contractId/state/at?at=2027-01-01 */
export async function getContractStateAt(contractId, at) {
  return instance({ baseURL }).get(`${base}/contract/${contractId}/state/at?at=${at}`);
}
